import React from "react";
import { PeriodRange } from "@linkfluence/models/date";
import Panel from "@ui-kit/popover/panel";
import Classification from "@radarly/components/filterbar/panels/classification/index";
import { useFilterbarClassificationPanel } from "@radarly/core/filters/use-cases";
import { Clause } from "@radarly/models/clause";
import { FullFacet } from "@radarly/models/facets";
import InnerPanel from "./inner-panel";

interface IProps {
  clause: Clause;
  facet: FullFacet;
  setClause: (clause: Clause) => void;
  hasTitle?: boolean;
  onApply: () => void;
  onCancel?: () => void;
  period: PeriodRange;
  validateLabel?: string;
  className?: string;
}

const RadarlyFilterbarPanelsClassification = ({
  setClause,
  clause,
  facet,
  onApply,
  onCancel,
  period,
  validateLabel,
  className,
}: IProps) => {
  const {
    size,
    locale,
    onReset,
    onChangeStatus,
    choices,
    levelChoices,
    loading,
    error,
    level,
    currentFilter,
    onChangeLevel,
    isEmpty,
  } = useFilterbarClassificationPanel(clause, facet, period, setClause);
  return (
    <Panel
      size={size}
      locale={locale}
      onClear={onReset}
      onApply={onApply}
      onCancel={onCancel}
      disabled={onCancel ? isEmpty : false}
      validateLabel={validateLabel}
      className={className}
    >
      <InnerPanel loading={loading} error={error} locale={locale}>
        <Classification
          choices={choices}
          levelChoices={levelChoices}
          currentLevel={level}
          onChangeLevel={onChangeLevel}
          currentFilter={currentFilter}
          onSelect={onChangeStatus}
          locale={locale}
          onReset={onReset}
        />
      </InnerPanel>
    </Panel>
  );
};

export default RadarlyFilterbarPanelsClassification;
